// Tipo de cambio de referencia MXN -> USD. Actualizar periódicamente
// (consultado en Banxico/mercados el 2026-08-12: ~$17.1 MXN por USD).
export const USD_MXN_RATE = 17.2

// Margen adicional aplicado al convertir de MXN a USD, para cubrir lo que
// se pierde en comisiones de conversión de divisas.
export const CURRENCY_MARKUP = 1.15

// Convierte los montos en MXN de un texto de precio (p. ej. "From $9,500 MXN/mo")
// a USD con el margen aplicado, cuando el locale activo es "en". En cualquier
// otro locale devuelve el texto sin modificar.
export function localizePrice(text, locale) {
  // Si no es inglés, no es un string de precio, o no contiene "MXN",
  // no hay nada que convertir: se devuelve el texto tal cual (español intacto).
  if (locale !== 'en' || typeof text !== 'string' || !text.includes('MXN')) {
    return text
  }

  // Busca cada monto "$X,XXX" dentro del texto (puede haber más de uno,
  // como en los rangos "$5,000 – $15,000 MXN") y lo reemplaza por su
  // equivalente en USD ya con el margen del 15% aplicado.
  const withUsdAmounts = text.replace(/\$([\d,]+)/g, (match, amount) => {
    const mxn = Number(amount.replace(/,/g, ''))
    if (Number.isNaN(mxn)) return match
    const usd = Math.ceil((mxn / USD_MXN_RATE) * CURRENCY_MARKUP)
    return `$${usd.toLocaleString('en-US')}`
  })

  // Una vez convertidos los montos, se reemplaza la etiqueta "MXN" por "USD"
  // (cubre también sufijos pegados como "MXN/mo" o "MXN/hr").
  return withUsdAmounts.replace(/MXN/g, 'USD')
}
